import type { ReactNode } from 'react';

export const symbol_vertical_shades: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M110-120q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-180 110-180h50v-600q0-24.75 17.63-42.38Q195.25-840 220-840h520q24.75 0 42.38 17.62Q800-804.75 800-780v600h50q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H110Zm110-60h105v-600H220v600Zm165 0h190v-600H385v600Zm250 0h105v-600H635v600Zm-415 0v-600 600Zm520 0v-600 600Z"
		/>
	</svg>
);
